import React from "react";
import {
    capitalizeFirstLetter,
    DropdownButton,
    DropdownItem,
    DropdownItemGroup,
    DropdownItemGroups,
    Icon,
    SidebarFooter,
    useNotifications,
    useTheme
} from "peggirkit";
import {ArrowLeftEndOnRectangleIcon, CogIcon, MoonIcon, SunIcon, UserCircleIcon} from "@heroicons/react/24/outline";
import {FormattedMessage, useIntl} from "react-intl";
import router from "@/routing/Router";
import useAuth from "@/context/authentication/use-auth";
import {useMutation} from "@tanstack/react-query";
import {notifyDanger} from "@/utils/NotifyUtils";
import {api} from "@/data/api";

const SidebarMenuFooter = () => {
    const {user} = useAuth();
    const intl = useIntl();
    const {isDark, toggleTheme} = useTheme();
    const {notify} = useNotifications();
    const {mutate, isPending} = useMutation({
        mutationFn: async () => api.auth.signOut(),
        onSuccess: () => window.location.replace(router.signIn.absolutePath()),
        onError: () => notifyDanger(intl.formatMessage({id: "systemError"}), notify),
    });

    return (
        <SidebarFooter containerClassname={"lg:-mb-4"}>
            <DropdownButton
                color={"secondary"}
                variant={"text"}
                containerClassname={"w-full"}
                hideChevron={false}
                align={"center"}
                width={"w-full"}
                iconBefore={
                    <Icon
                        className={"text-eat-yellow-800 dark:text-eat-yellow-600"}
                        icon={UserCircleIcon}
                    />
                }
                items={
                    <DropdownItemGroups>
                        <DropdownItemGroup>
                            <DropdownItem
                                buttonAction={{
                                    as: "reactRouterLink",
                                    actionProps: {to: router.account.absolutePath()}
                                }}
                                icon={<Icon icon={CogIcon}/>}
                            >
                                <FormattedMessage id={"account"}/>
                            </DropdownItem>
                            <DropdownItem
                                buttonAction={{
                                    as: "button",
                                    actionProps: {onClick: toggleTheme}
                                }}
                                icon={<Icon icon={isDark ? SunIcon : MoonIcon}/>}
                            >
                                <FormattedMessage id={isDark ? "lightMode" : "darkMode"}/>
                            </DropdownItem>
                        </DropdownItemGroup>

                        <DropdownItemGroup>
                            <DropdownItem
                                icon={<Icon icon={ArrowLeftEndOnRectangleIcon}/>}
                                color={"danger"}
                                loading={isPending}
                                buttonAction={{
                                    as: "button",
                                    actionProps: {
                                        onClick: e => {
                                            e.preventDefault();
                                            mutate();
                                        },
                                    }
                                }}
                            >
                                <FormattedMessage id={"signOut"}/>
                            </DropdownItem>
                        </DropdownItemGroup>
                    </DropdownItemGroups>
                }
                loading={user == null}
                contentsClassname={"text-xs"}
            >
                {capitalizeFirstLetter(user?.username || "")}
            </DropdownButton>
        </SidebarFooter>
    );
};

export default SidebarMenuFooter;